module.exports = __webpack_public_path__ + "img/Like-new.84c466e6.svg";